import { Step, StepsContainer } from './styled';

export type TDotsStepperProps = {
  activeStep: number;
  steps: number;
  onStepClick: (step: number) => void;
};

export const DotsStepper = ({ activeStep, steps, onStepClick }: TDotsStepperProps) => (
  <StepsContainer>
    {Array.from(new Array(steps).keys()).map((step) => (
      <Step key={step} active={activeStep === step} onClick={() => onStepClick(step)} />
    ))}
  </StepsContainer>
);
